import { render, staticRenderFns } from "./BodyAddModal.vue?vue&type=template&id=2650cc05&"
import script from "./BodyAddModal.vue?vue&type=script&lang=js&"
export * from "./BodyAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BodyAddModal.vue"
export default component.exports